/**
 * An interface for 'building' up a collection of actions over time.
 *
 * Currently mainly used for collecting actions to perform when the application is closed.
 *
 * The advantage of this is that different parts of the application can request different actions be taken without
 * having to implement it all in one central place with access to all of the dependencies that might require.
 *
 * Each action has a name, and the action is represented by a thunk. Attempting to create an action with a name that already exists will overwrite the last action.
 */

export type Actions = Record<string, () => void>;

export const create = (): Actions => ({});

export const add = (name: string, action: () => void, actions: Actions): Actions => {
    actions[name] = action;

    return actions;
};

export const run = (actions: Actions): void => {
    Object.values(actions).forEach(f => f());
};